import React, { Component, useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "./header.less";
import logo from "@/assets/icon/logo.png";
import downLoad from "@/assets/icon/downLoad.png";
import iconMenu from "@/assets/icon/icon-menu.png";
import { Radio, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { getParameters } from '@/utils/utils';
function Header() {
  const { t, i18n } = useTranslation();
  const history  = useHistory()
  const { certno } = getParameters() || {}
  const navList = [
    {
      title: t('首页'),
      path: "/home",
    },
    {
      title: "产品服务",
      path: "/product",
    },
    {
      title: t('客户案例'),
      path: "/case",
    },
    {
      title: t('信用评估'),
      path: "/grade",
    },
    {
      title: t('信用报告'),
      path: "/report",
    },
    {
      title: t('关于我们'),
      path: "/about",
    },
  ];
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [locale, setLocale] = useState('zh')
  useEffect(()=>{
    history.listen((location) => {
      setShowMobileNav(false)
    })
    let lsLocal = localStorage.getItem('blur-website-locale');
    if ( !!lsLocal && lsLocal ) {
      i18n.changeLanguage(lsLocal)
      setLocale(lsLocal)
    } else {
      i18n.changeLanguage('zh')
      setLocale('zh')
      localStorage.setItem('blur-website-locale', 'zh');
    }
  },[])
  // const onLocaleChange = value => {
  //   i18n.changeLanguage(value)
  //   setLocale(value)
  //   localStorage.setItem('blur-website-locale', value);
  // }
  const onDownLoadClient = () => {
    history.push('/downLoad')
  }

  return (
    <>
      <div className="site-header-nav">
        <img className="site-header-nav-logo" src={logo}  alt="logo"/>
        <div className="site-header-nav-btn-group">
          {navList.map((item) => (
            <NavLink
            key={item.path}
              to={certno ? `${item.path}?certno=${certno}` : item.path}
              activeClassName="nav-active"
              className="site-header-nav-btn-group-item"
            >
              {item.title}
            </NavLink>
          ))}
          <img className="site-header-nav-downLoad" src={downLoad}  alt="downLoad" onClick={() => {onDownLoadClient()}}/>
          {/* <Radio.Group value={locale} onChange={e=>onLocaleChange(e.target.value)}>
            <Radio.Button key="en" value="en">
              English
            </Radio.Button>
            <Radio.Button key="zh" value="zh">
              中文
            </Radio.Button>
          </Radio.Group> */}
        </div>
      </div>

      <div
      className={[
            "site-header-mobile-nav",
            showMobileNav ? "show-nav" : null,
          ].join(" ")}>
        <div className="site-header-mobile-nav-header">
          <img className="site-header-mobile-nav-header-logo" src={logo}  alt="logo"/>
          {/* <Radio.Group style={{marginLeft: '20px'}} value={locale} onChange={e=>onLocaleChange(e.target.value)}>
            <Radio.Button key="en" value="en">
              English
            </Radio.Button>
            <Radio.Button key="zh" value="zh">
              中文
            </Radio.Button>
          </Radio.Group> */}
          <img onClick={()=>{setShowMobileNav(!showMobileNav)}}
           alt="menu"
          className={[
            "site-header-mobile-nav-header-icon",
            showMobileNav ? "show-nav" : null,
          ].join(" ")}
          src={iconMenu} />
        </div>

        <div
          className="site-header-mobile-nav-btn-group"
        >
          {navList.map((item) => (
            <NavLink
            key={item.path}
              to={item.path}
              activeClassName="nav-active"
              className="site-header-mobile-nav-btn-group-item"
            >
              {item.title}
            </NavLink>
          ))}

          <img className="site-header-mobile-nav-header-downLoad" src={downLoad}  alt="downLoad" onClick={() => {onDownLoadClient()}}/>
        </div>
      </div>
    </>
  );
}

export default Header;
